export default __webpack_public_path__ + "assets/profeature-grid.f221d41a8c73cdff85f02e8ddb095902.jpg";